import JSON5 from 'process-js-objects'
import { initI18n, dispatchCustomEventGlobally } from 'www/utils'
import Vue from 'www/vue_components'
import vuetify from 'www/modules/vuetify-plugin'
import DocumentsVerified from 'www/vue_components/common/DocumentsVerified/DocumentsVerified.vue'

const el = document.querySelector('.vue-documents-verified-mount')

const mountDocumentsVerified = async () => {
  await initI18n({ bundle: 'vue_components/common/DocumentsVerified' })

  if (el) {
    new Vue({
      vuetify,
      el,
      render: h => h(DocumentsVerified),
    })
  }
}

mountDocumentsVerified()

function dispatchDocumentsVerifiedOpen(event) {
  const element = event.target.closest('[data-documents-verified-open]')

  if (!element) {
    return
  }

  event.preventDefault()

  const data = JSON5.parse(element.getAttribute('data-documents-verified-open'))

  dispatchCustomEventGlobally('documents-verified:open', data)
}

window.addEventListener('click', dispatchDocumentsVerifiedOpen)
